import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/free-mode';
import 'swiper/css/a11y';
import 'swiper/css/keyboard';
import 'swiper/css/thumbs';
export default class HeroHome extends HTMLElement {
  constructor() {
    super();
    this.heroSlider = this.querySelector('[data-hero-slider]');
    this.initSlider();
    this.initCardLinks();
  }

  // Make the whole card clickable by forwarding clicks to the card's own
  // link (the button). Delegated on the host so it also covers the slides
  // Swiper clones for looping.
  initCardLinks() {
    this.addEventListener('click', event => {
      // Let real interactive elements (button link, swiper arrows) behave normally.
      if (event.target.closest('a, button')) return;

      // Ignore clicks that are actually text selections.
      if (window.getSelection && window.getSelection().toString()) return;
      var slide = event.target.closest('.swiper-slide');
      var link = slide && slide.querySelector('a[href]');
      if (link) link.click();
    });
  }
  initSlider() {
    return new Swiper(this.heroSlider, {
      modules: [Navigation],
      loop: true,
      spaceBetween: 8,
      updateOnImagesReady: true,
      slidesPerView: 1.2,
      navigation: {
        nextEl: '.swiper-button-next-product',
        prevEl: '.swiper-button-prev-product'
      },
      breakpoints: {
        768: {
          slidesPerView: 3.1
        }
      }
    });
  }
}
customElements.define('hero-home', HeroHome);